/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Negotiation_Analyze_Job_TitleInputs */

const en_negotiation_analyze_job_title = /** @type {(inputs: Negotiation_Analyze_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze a Job Posting`)
};

const de_negotiation_analyze_job_title = /** @type {(inputs: Negotiation_Analyze_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze a Job Posting`)
};

const fr_negotiation_analyze_job_title = /** @type {(inputs: Negotiation_Analyze_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze a Job Posting`)
};

const es_negotiation_analyze_job_title = /** @type {(inputs: Negotiation_Analyze_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze a Job Posting`)
};

const it_negotiation_analyze_job_title = /** @type {(inputs: Negotiation_Analyze_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze a Job Posting`)
};

const nl_negotiation_analyze_job_title = /** @type {(inputs: Negotiation_Analyze_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze a Job Posting`)
};

const pl_negotiation_analyze_job_title = /** @type {(inputs: Negotiation_Analyze_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze a Job Posting`)
};

const fi_negotiation_analyze_job_title = /** @type {(inputs: Negotiation_Analyze_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze a Job Posting`)
};

const da_negotiation_analyze_job_title = /** @type {(inputs: Negotiation_Analyze_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze a Job Posting`)
};

const sv_negotiation_analyze_job_title = /** @type {(inputs: Negotiation_Analyze_Job_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyze a Job Posting`)
};

/**
* | output |
* | --- |
* | "Analyze a Job Posting" |
*
* @param {Negotiation_Analyze_Job_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const negotiation_analyze_job_title = /** @type {((inputs?: Negotiation_Analyze_Job_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Negotiation_Analyze_Job_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_negotiation_analyze_job_title(inputs)
	if (locale === "fr") return fr_negotiation_analyze_job_title(inputs)
	if (locale === "es") return es_negotiation_analyze_job_title(inputs)
	if (locale === "it") return it_negotiation_analyze_job_title(inputs)
	if (locale === "nl") return nl_negotiation_analyze_job_title(inputs)
	if (locale === "pl") return pl_negotiation_analyze_job_title(inputs)
	if (locale === "fi") return fi_negotiation_analyze_job_title(inputs)
	if (locale === "da") return da_negotiation_analyze_job_title(inputs)
	if (locale === "sv") return sv_negotiation_analyze_job_title(inputs)
	return en_negotiation_analyze_job_title(inputs)
});